// extracted by mini-css-extract-plugin
module.exports = {"icon":"third-machine-switcher_icon__3z8cf","emptyIcon":"third-machine-switcher_emptyIcon__3nIQa","noWrap":"third-machine-switcher_noWrap__3gcr-"};